// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle_Toggle__PdR4i","CloseContainer":"Toggle_CloseContainer__3lbuS"};